'use client';

import * as Dialog from '@radix-ui/react-dialog';
import type { ComponentProps } from 'react';

export * from '@radix-ui/react-dialog';

// Portals inherit the new design tokens without changing globals used by checkout/profile.
export function Portal({ children, ...props }: ComponentProps<typeof Dialog.Portal>) {
  return (
    <Dialog.Portal {...props}>
      <div className="storefront-portal">{children}</div>
    </Dialog.Portal>
  );
}
